
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/errors/api",
      function () {
        return require("private-next-pages/docs/errors/api.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/errors/api"])
      });
    }
  